import { render, staticRenderFns } from "./scorereviews.vue?vue&type=template&id=d645420c&scoped=true&"
import script from "./scorereviews.vue?vue&type=script&lang=js&"
export * from "./scorereviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d645420c",
  null
  
)

export default component.exports